import { render } from "./SitesList.vue?vue&type=template&id=3c9445a9&scoped=true&ts=true"
import script from "./SitesList.vue?vue&type=script&lang=ts"
export * from "./SitesList.vue?vue&type=script&lang=ts"

import "./SitesList.vue?vue&type=style&index=0&id=3c9445a9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9445a9"]])

export default __exports__